// Common base class for slides that show subitems.
export function ItemsSlide() {
	this.timeout = 4000;
	this.itemsPerSlide = 4;
	this.intervalId = null;
	this.currentIndex = 0;
	this.previous = null;
	this.parent = null;
	this.currentItemCount = 0;

	this.items = [];
}
ItemsSlide.prototype.addItem = function(item) {
	this.items.push(item);
	if (this.createElement) {
		item.element = this.createElement(item);
		if (this.parent) {
			this.parent.appendChild(item.element);
		}
	}
};
ItemsSlide.prototype.addItems = function(items) {
	var self = this;
	items.forEach(function(item) {
		self.addItem(item);
	});
};
ItemsSlide.prototype.clearItems = function() {
	this.items = [];
	this.currentIndex = 0;
	if (this.parent) {
		while (this.parent.childNodes.length) {
			this.parent.removeChild(this.parent.childNodes[0]);
		}
	}
};
ItemsSlide.prototype.elementCreatedBase = function(parent) {
	var self = this;
	this.parent = parent;
	if (this.createElement && this.parent) {
		this.items.forEach(function(item) {
			item.element = self.createElement(item);
			self.parent.appendChild(item.element);
		});
	}
};
ItemsSlide.prototype.startItems = function() {
	if (this.current) {
		this.current.element.classList.remove('active');
		this.current = null;
	}
	this.currentItemCount = 0;
	this.intervalId = setInterval(this.onInterval.bind(this), this.timeout);
	this.onInterval();
};
ItemsSlide.prototype.stopItems = function() {
	if (this.intervalId) {
		clearInterval(this.intervalId);
	}
};
ItemsSlide.prototype.onInterval = function() {
	this.currentItemCount++;
	if (this.currentItemCount > this.itemsPerSlide && this.onTriggerNext) {
		this.onTriggerNext();
		return;
	}

	// For Twitter and Instagram, we want to show the four most recent tweets.
	// If we're told there are less than four, than we should just show as
	// many as we have. And once that's done, move on.
	if (!this.cycle && this.currentIndex >= this.items.length) {
		this.currentIndex = 0;
		this.onTriggerNext();
		return;
	}

	this.currentIndex = this.currentIndex % this.items.length;

	var previous = this.current;
	var current = this.current = this.items[this.currentIndex % this.items.length];

	if (previous) {
		previous.element.classList.remove('active');
	}
	current.element.classList.add('active');

	// Set up what happens when a transition ends.
	var currentTransitionEnd = function(e) {
		// We can get this event when events end in child elements. That is
		// definitely not what we want. So, only handle this when the target
		// is the element on which the event is set.
		if (e.target !== this) {
			return;
		}
		// Remove the listener. We don't want to end up with a whole slew
		// of listeners that cause weird bugs.
		current.element.removeEventListener('transitionend', currentTransitionEnd, false);
		// Remove the transition classes.
		current.element.classList.remove('item-enter');
		current.element.classList.remove('item-enter-active');
	};
	var previousTransitionEnd = function(e) {
		// We can get this event when events end in child elements. That is
		// definitely not what we want. So, only handle this when the target
		// is the element on which the event is set.
		if (e.target !== this) {
			return;
		}
		// Remove the listener. We don't want to end up with a whole slew
		// of listeners that cause weird bugs.
		previous.element.removeEventListener('transitionend', previousTransitionEnd, false);
		// Remove the transition classes.
		previous.element.classList.remove('item-exit');
		previous.element.classList.remove('item-exit-active');
	};

	if (previous) {
		previous.element.addEventListener('transitionend', previousTransitionEnd);
		current.element.addEventListener('transitionend', currentTransitionEnd);

		previous.element.classList.add('item-exit');
		current.element.classList.add('item-enter');

		setTimeout(function() {
			previous.element.classList.add('item-exit-active');
			current.element.classList.add('item-enter-active');
		}, 0);
	}

	this.currentIndex++;
};
